import {Component} from '@angular/core';

@Component({
  selector: 'app-copy-return-detail-success',
  templateUrl: './copy-return-detail-success.component.html',
  styleUrls: ['./copy-return-detail-success.component.scss']
})
export class CopyReturnDetailSuccessComponent {

}
